import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 px-4 sm:px-6 bg-white" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-6" data-id="element-145">
            El problema no eres tú.{' '}
            <span className="text-brand-primary" data-id="element-146">Es el sistema.</span>
          </h2>
          <p className="text-lg text-brand-text/80 leading-relaxed max-w-3xl mx-auto" data-id="element-147">
            El problema es que nos enseñaron que comer sano requiere ser una
            esclava de la cocina o pasar todo el domingo pesando porciones de
            arroz seco en 20 recipientes idénticos. Eso no es vida, es otra
            obligación más en tu lista infinita.
          </p>
          <p className="text-lg text-brand-text/80 leading-relaxed max-w-3xl mx-auto mt-4" data-id="element-148">
            Has intentado buscar recetas en Pinterest, pero terminas con 50
            pestañas abiertas, gastando una fortuna en el súper y viendo cómo la
            mitad de los vegetales se pudren en el cajón porque "no tuviste
            tiempo" de seguir la receta paso a paso.
          </p>
        </motion.div>

        <div className="bg-brand-bg rounded-2xl p-6 md:p-10 border border-brand-light" data-id="element-149">
          <h3 className="text-xl md:text-2xl font-bold text-brand-text mb-6 text-center" data-id="element-150">
            Por qué lo que has intentado no funciona:
          </h3>

          <div className="space-y-4" data-id="element-151">
            {['Las recetas sueltas no son un sistema; son parches que aumentan tu cansancio mental.', 'El Meal Prep tradicional es aburrido porque te obliga a comer lo mismo 5 días seguidos.', 'Comprar por impulso sin una estructura modular garantiza el desperdicio de comida y dinero.', 'Intentar cocinar "algo rápido" cada noche drena tu energía de reserva después del trabajo.'].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-152">
                <XCircleIcon className="text-red-400 flex-shrink-0 mt-1" size={24} data-id="element-153" />
                <p className="text-brand-text/90 font-medium" data-id="element-154">{item}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}